<div id="device-configuration-list-component" class="component-inner-wrapper device-configuration-list-component-class">
    <main class="main-content">
        <div class="container">
            <div class="breadcrumb">
                <span>OTA</span>
                <span>></span>
                <span class="ele_link" [routerLink]="['/ota/device-configuration-list']" >Device Configuration List</span>
            </div>
            <div class="aggrid-criteria">
                <div class="grid-filter-criteria config-list-filter-row">
                    <div class="config-list-title">
                        <h1 class="page-title">Device Configuration List</h1>
                    </div>
                    <div class="customer-filter">
                      <label class="col-form-label me-2">Customer</label>
                      <select class="custom-dropdown" [(ngModel)]="selectedCustomer" (change)="onHeaderCustomerChange($event)">
                        <option value="All">{{ customerDropdownSelectLabel }}</option>
                        <option *ngFor="let item of customerList" [value]="item.customerName">
                            {{ item.customerName }}
                        </option>
                      </select>
                    </div>
                    <div class="group-filter">
                      <label class="col-form-label me-2">Group</label>
                      <select class="custom-dropdown" [(ngModel)]="selectedGroup" (change)="onHeaderGroupChange($event)" [disabled]="isGroupDropdownDisabled" name="group">
                        <option value="">{{ groupDropdownEmptyLabel }}</option>
                        <option *ngFor="let group of groups" [value]="group.groupName">{{ group.groupName }}</option>
                      </select>
                    </div>
                </div>
            </div>

            <div class="content-wrapper content-wrapper-aggrid">
                <div class="component-ag-grid-wrapper config-list-grid-shell"
                [style.--mc-ag-host-height.px]="gridHostHeightPx"
                [style.--mc-ag-page-size]="loadedRowCount || 1"
                (contextmenu)="preventDefaultContextMenu($event)"
                mcAgGridCopyCellTooltip style="position: relative;">
                    <ag-grid-angular
                        class="ag-theme-alpine"
                        [style.height.px]="gridHostHeightPx"
                        [style.max-height.px]="gridHostHeightPx"
                        [rowData]="rowData"
                        [rowModelType]="'infinite'"
                        [columnDefs]="columnDefs"
                        [defaultColDef]="defaultColDef"
                        [paginationPageSize]="paginationPageSize"
                        [paginationPageSizeSelector]="pageSizeOptions"
                        [cacheBlockSize]="paginationPageSize"
                        [pagination]="true"
                        [datasource]="dataSource"
                        (gridReady)="onGridReady($event)"
                        (paginationChanged)="onPaginationChanged($event)"
                        (filterChanged)="onGridFilterChanged()"
                        (cellContextMenu)="onCellContextMenu($event)"
                        (cellClicked)="onCellClicked($event)"
                    >
                    </ag-grid-angular>
                    <div class="custom-context-menu"
                        [ngStyle]="{'top.px': contextMenuPosition.y, 'left.px': contextMenuPosition.x}"
                        *ngIf="contextMenuVisible">
                        <ul>
                            <li (click)="handleCopy()">Copy Value</li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </main>
</div>
